module.exports = __webpack_public_path__ + "static/media/Icon_menu_consumables.40fc90e3.svg";